import { render, staticRenderFns } from "./reportOwnerPayFeeList.vue?vue&type=template&id=4cc06ba0&scoped=true"
import script from "./reportOwnerPayFeeList.vue?vue&type=script&lang=js"
export * from "./reportOwnerPayFeeList.vue?vue&type=script&lang=js"
import style0 from "./reportOwnerPayFeeList.vue?vue&type=style&index=0&id=4cc06ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc06ba0",
  null
  
)

export default component.exports